import isEmpty from 'lodash/isEmpty';
import { DELIVERY_ISSUE, RETURN_FROM_CUSTOMER, USED_OTHER_DELIVERY_WITH_DETAILS } from './DTHandleCheggBookIssuesMap';

export const buildBookIssuesOrderPayload = ({
  additionalDetails: otherDetails,
  approach,
  carrierName: carrier,
  deliveryType,
  issueType,
  selectedBookIssuesOrders,
  selectedOrderItems = [],
  selectedItems = {},
  trackingCode: code,
}) => {
  const { id, type, orderRowLines } = selectedBookIssuesOrders;
  let order = {
    type,
    id,
    issueType,
    approach,
    orderRowLines: [],
  };

  const selectedOrderRowLines = orderRowLines.filter((orderRowLine) => {
    const validSelectedOrderItem = selectedOrderItems.find(
      (selectedOrderItem) => orderRowLine.attributes.isbn === selectedOrderItem.itemSKU
    );

    return selectedItems[validSelectedOrderItem?.itemId];
  });

  if (isEmpty(selectedOrderRowLines)) {
    throw new Error('Something went wrong while selecting the book orders');
  }

  for (const selectedOrderRow of selectedOrderRowLines) {
    order.orderRowLines.push({ type: selectedOrderRow.type, id: selectedOrderRow.id });
  }

  if (DELIVERY_ISSUE === issueType) {
    order = {
      ...order,
      deliveryType,
    };

    if (RETURN_FROM_CUSTOMER === deliveryType) {
      order = {
        ...order,
        trackingInfo: { otherDetails },
      };

      if (USED_OTHER_DELIVERY_WITH_DETAILS === approach) {
        order.trackingInfo = {
          ...order.trackingInfo,
          code,
          carrier,
        };
      }
    }
  }

  return order;
};
